var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo fw4 z-3 fixed brown title title-ns"},[_c('img',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.handleScroll),expression:"handleScroll"}],attrs:{"src":require("../assets/images/logo.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }